module.exports = __webpack_public_path__ + "img/4_82.993aef69.png";